import { filterPreparation } from "./filter/filterPreparation.js";
import filter from "./filter/filter.js";
import { mergeFilters } from "./filter/mergeFilters.js";
import { jsonToItems } from "./json_to_items/json_to_items.js";
import {
  mergeItems,
  compareItems,
  populateWithItemRef,
} from "./merge_compare_items/merge_compare_items.js";
import { group } from "./filter/group.js";
import { searchValue } from "./filter/utils.js";
import populateItems from "./populate_items/populate_items.js";
import { populateWithDate, getDate, checkRecurringDate } from "./get_date/get_date.js";
import { mergeObjects } from "./merge_objects/merge_objects.js";
import { mergeChunks } from "./merge_chunks/merge_chunks.js";
import { makeNestedList } from "./nested_list/nested_list.js";
import MergeFields from "./MergeFields/MergeFields.js";
import ItemsSelection from "./ItemsSelection/ItemsSelection.js";

import { compare_items_lists_Worker } from "./compare_items_lists_worker/compare_items_lists.worker.js";
import { compiler } from "./json_constructor/json_constructor.js";
import AppsTemplateService from "./AppsTemplateService/AppsTemplateService.js";
import { FileHelper } from "./FIleHelper/FileHelper.js";
import { compareObjects } from "./compareObjects/compareObjects.js";
import { dynamicPromiseAll } from "./dynamicPromiseAll/dynamicPromiseAll.js";
import { sortItems } from './filter/sortItems.js';

export class Utils {
  constructor(gudhub) {
    this.gudhub = gudhub;
    this.MergeFields = new MergeFields(gudhub);
    this.ItemsSelection = new ItemsSelection(gudhub);
    this.AppsTemplateService = new AppsTemplateService(gudhub);
    this.FileHelper = new FileHelper(gudhub);
  }

  prefilter(filters_list, variables = {}) {
    return filterPreparation(
      filters_list,
      this.gudhub.storage,
      this.gudhub.pipeService,
      variables
    );
  }

  filter(items, filter_list) {
    return filter(items, filter_list);
  }

  mergeFilters(src, dest) {
    return mergeFilters(src, dest);
  }

  group(fieldGroup, items) {
    return group(fieldGroup, items);
  }

  async getFilteredItems(
    items = [],
    filters_list = [],
    element_app_id,
    app_id,
    item_id,
    field_group = "",
    search,
    search_params
  ) {
    const modified_filters_list = await this.prefilter(
      filters_list,
      {
        element_app_id,
        app_id,
        item_id
      }
    );
    const itemsList = this.filter(items, modified_filters_list);
    const newItems = this.group(field_group, itemsList);
    return newItems
      .filter((newItem) => {
        if (search) {
          return searchValue([newItem], search).length === 1;
        } else return true;
      })
      .filter((newItem) => {
        if (search_params) {
          return searchValue([newItem], search_params).length === 1;
        } else return true;
      });
  }

  jsonToItems(json, map) {
    return jsonToItems(json, map);
  }

  getDate(queryKey) {
    return getDate(queryKey);
  }

  checkRecurringDate(date, option) {
    return checkRecurringDate(date, option);
  }

  populateItems(items, model, keep_data) {
    return populateItems(items, model, keep_data);
  }
  
  populateWithDate(items, model) {
    return populateWithDate(items, model);
  }

  populateWithItemRef(
    sourceItemsRef,
    srcFieldIdToCompare,
    destinationItems,
    destFieldIdToCompare,
    destFieldForRef,
    app_id
  ) {
    return populateWithItemRef(
      sourceItemsRef,
      srcFieldIdToCompare,
      destinationItems,
      destFieldIdToCompare,
      destFieldForRef,
      app_id
    );
  }

  compareItems(sourceItems, destinationItems, fieldToCompare) {
    return compareItems(sourceItems, destinationItems, fieldToCompare);
  }

  mergeItems(sourceItems, destinationItems, mergeByFieldId) {
    return mergeItems(sourceItems, destinationItems, mergeByFieldId);
  }

  mergeObjects(target, source, optionsArgument) {
    return mergeObjects(target, source, optionsArgument);
  }

  makeNestedList(arr, id, parent_id, children_property, priority_property) {
    return makeNestedList(arr, id, parent_id, children_property, priority_property);
  }

  mergeChunks(chunks) {
    return mergeChunks(chunks);
  }

  mergeFieldLists(fieldsToView, fieldList) {
    return this.MergeFields.mergeFieldLists(fieldsToView, fieldList);
  }

  createFieldsListToView(appId, tableSettingsFieldListToView) {
    return this.MergeFields.createFieldsListToView(appId, tableSettingsFieldListToView);
  }

  createFieldsListToViewWithDataType(appId, tableSettingsFieldListToView) {
    return this.MergeFields.createFieldsListToViewWithDataType(appId, tableSettingsFieldListToView);
  }

  selectItems(appId, items) {
    return this.ItemsSelection.selectItems(appId, items);
  }

  getSelectedItems(appId) {
    return this.ItemsSelection.getSelectedItems(appId);
  }

  clearSelectedItems(appId) {
    return this.ItemsSelection.clearSelectedItems(appId);
  }

  isItemSelected(appId, itemId) {
    return this.ItemsSelection.isItemSelected(appId, itemId);
  }

  jsonConstructor(scheme, item, variables, appId){
    return compiler(scheme, item, this, variables, appId)
  }

  fileInstallerHelper(appId, items, elementId) {
    return this.FileHelper.fileInstallerHelper(appId, items, elementId);
  }

  createAppsFromTemplate(pack, maxNumberOfInsstalledItems, progressCallback, installFromMaster) {
    return this.AppsTemplateService.createAppsFromTemplate(pack, maxNumberOfInsstalledItems, progressCallback, installFromMaster);
  }

  createApps(pack) {
    return this.AppsTemplateService.createApps(pack);
  }

  createItems(create_apps, maxNumberOfInsstalledItems) {
    return this.AppsTemplateService.createItems(create_apps, maxNumberOfInsstalledItems);
  }

  compareObjects(obj1, obj2) {
    return compareObjects(obj1, obj2);
  }
  
  compareAppsItemsLists(items_list1, items_list2, callback) {
    const chunkWorkerBlob = new Blob([compare_items_lists_Worker()], {
      type: "application/javascript",
    });
    this.worker = new Worker(URL.createObjectURL(chunkWorkerBlob));
    this.worker.postMessage({ items_list1, items_list2 });
    this.worker.addEventListener("message", (event) => {
      const { diff } = event.data;
      callback(diff);
    });
  }

  dynamicPromiseAll(promisesArray) {
    return dynamicPromiseAll(promisesArray);
  }

  sortItems(items, options) {
    return sortItems(items, options);
  }
}
